var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCooktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 34.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Cooktop Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.436,3.828c2.065,0,3.745,1.68,3.745,3.745s-1.68,3.745-3.745,3.745-3.745-1.68-3.745-3.745,1.68-3.745,3.745-3.745ZM9.436,12.233c2.57,0,4.66-2.091,4.66-4.66s-2.09-4.66-4.66-4.66-4.66,2.091-4.66,4.66,2.091,4.66,4.66,4.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.564,3.828c2.065,0,3.745,1.68,3.745,3.745s-1.68,3.745-3.745,3.745-3.745-1.68-3.745-3.745,1.68-3.745,3.745-3.745ZM38.564,12.233c2.57,0,4.66-2.091,4.66-4.66s-2.09-4.66-4.66-4.66-4.66,2.091-4.66,4.66,2.091,4.66,4.66,4.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.709,18.878c-3.504,0-6.354-2.85-6.354-6.354s2.85-6.354,6.354-6.354,6.353,2.85,6.353,6.354-2.85,6.354-6.353,6.354ZM23.709,5.243c-4.015,0-7.282,3.267-7.282,7.282s3.267,7.282,7.282,7.282,7.281-3.267,7.281-7.282-3.266-7.282-7.281-7.282Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.145,25.269c-2.851,0-5.171-2.32-5.171-5.171s2.32-5.171,5.171-5.171,5.171,2.32,5.171,5.171-2.32,5.171-5.171,5.171ZM9.145,13.981c-3.373,0-6.117,2.744-6.117,6.117s2.744,6.117,6.117,6.117,6.117-2.744,6.117-6.117-2.744-6.117-6.117-6.117Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.273,25.269c-2.852,0-5.171-2.32-5.171-5.171s2.32-5.171,5.171-5.171,5.171,2.32,5.171,5.171-2.319,5.171-5.171,5.171ZM38.273,13.981c-3.373,0-6.117,2.744-6.117,6.117s2.744,6.117,6.117,6.117,6.116-2.744,6.116-6.117-2.744-6.117-6.116-6.117Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.757,28.102H1.243V1.222c0-.054.045-.099.1-.099h45.315c.055,0,.1.045.1.099v26.88ZM46.757,33.148c0,.055-.045.099-.1.099H1.343c-.055,0-.1-.045-.1-.099v-4.208h45.514v4.208ZM46.657,0H1.343C.666,0,.116.548.116,1.222v31.926c0,.674.55,1.222,1.227,1.222h45.315c.677,0,1.227-.548,1.227-1.222V1.222c0-.674-.55-1.222-1.227-1.222Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.175,
    cy: 30.875,
    r: 1.165
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30.875,
    r: 1.165
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.349,
    cy: 30.875,
    r: 1.165
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.068,
    cy: 30.875,
    r: 1.165
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.825,
    cy: 30.875,
    r: 1.165
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.883,23.302h4.66c.161,0,.291.13.291.291s-.13.291-.291.291h-4.66c-.161,0-.291-.13-.291-.291s.13-.291.291-.291Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.874,23.302h4.66c.161,0,.291.13.291.291s-.13.291-.291.291h-4.66c-.161,0-.291-.13-.291-.291s.13-.291.291-.291Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.883,25.049h4.66c.161,0,.291.13.291.291s-.13.291-.291.291h-4.66c-.161,0-.291-.13-.291-.291s.13-.291.291-.291Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.874,25.049h4.66c.161,0,.291.13.291.291s-.13.291-.291.291h-4.66c-.161,0-.291-.13-.291-.291s.13-.291.291-.291Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.145,23.424c-1.834,0-3.326-1.492-3.326-3.326s1.492-3.326,3.326-3.326,3.326,1.492,3.326,3.326-1.492,3.326-3.326,3.326ZM9.145,16.311c-2.088,0-3.787,1.699-3.787,3.787s1.699,3.786,3.787,3.786,3.786-1.699,3.786-3.786-1.699-3.787-3.786-3.787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooktop);
export default __webpack_public_path__ + "static/media/cooktop.9b22c299b6a93ce14feabd8601282577.svg";
export { ForwardRef as ReactComponent };